<template>
  <div class="global-toaster-container">
    <div class="alert show"
         :class="[globalToasterClass, showToasterClass, variantClass]"
         role="alert"
         id="global-toaster">
      <strong>{{ toasterShow.message }}</strong>
      <button type="button"
              class="close"
              :class="[hideCloseButtonClass]"
              data-dismiss="alert"
              aria-label="Close"
              @click.stop.prevent="hideToaster">
        <!--<span aria-hidden="true">&times;</span>-->
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'GlobalToaster',
  data() {
    return {
    };
  },
  watch: {
    toasterShow(newValue) {
      // Expected newValue is the globalToaster data in store
      // Show if show = true then set hiding action from duration
      if (newValue.show === true) {
        setTimeout(() => this.hideToaster(), this.toasterShow.duration);
      }
    },
  },
  computed: {
    ...mapGetters({
      toasterShow: 'getGlobalToaster',
    }),
    variantClass() {
      return `alert-${this.toasterShow.variant}`;
    },
    showToasterClass() {
      return this.toasterShow.show ? 'global-toaster-alert-show' : '';
    },
    hideCloseButtonClass() {
      return this.toasterShow.show ? '' : 'global-toaster-alert-close-button-hide';
    },
    globalToasterClass() {
      return 'global-toaster-alert';
    },
  },
  methods: {
    hideToaster() {
      this.$store.dispatch('hideGlobalToaster');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .global-toaster-container {
    position: absolute;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 10001;

    .global-toaster-alert {
      position: fixed;
      bottom: 3px;
      left: -100% !important;
      width: 94%;
      transition: left 250ms ease-in !important;
    }

    .global-toaster-alert-show {
      left: 2% !important;
    }

    .global-toaster-alert-close-button-hide {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/utils/GlobalToaster.vue